// @flow

import React, { type Node } from 'react';
import { LinkButton } from '../commons/render-helpers';


export function PagofacilInformation(): Node {
  return (
    <>
      <h1>Dónde pagar</h1>
      <p>Haz clic a continuación para encontrar la sucursal más cercana.</p>
      <br/>
      <FindPagoFacilButton inverseStyle={true} buttonMessage="Ver pagofácil más cercano"/>
    </>
  );
}

export function FindPagoFacilButton({ buttonMessage, inverseStyle = false }: FindPagoFacilButtonProps): Node {
  const url = 'https://www.e-pagofacil.com/';

  return (
    <LinkButton inverseStyle={inverseStyle} aria-label={buttonMessage} type="primary" flat as="a" target="blank" href={url} contentDesktop={buttonMessage} contentMobile={buttonMessage} />
  );
}

type FindPagoFacilButtonProps = {|
  buttonMessage: string,
  inverseStyle ?: boolean,
|};
